import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { subscribeTable } from '../lib/realtime';
import type { Transaction } from '../lib/types';

export function useTransactions(driverId: string | undefined) {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async () => {
    if (!driverId) return;
    const { data, error: err } = await supabase
      .from('transactions')
      .select(
        '*, trip:trips(id,origin_address,dest_address,origin_lat,origin_lng,dest_lat,dest_lng,fare,payment_method,platform,started_at,ended_at,distance_km)'
      )
      .eq('driver_id', driverId)
      .order('occurred_at', { ascending: false });
    if (err) setError(err.message);
    else setTransactions((data ?? []) as Transaction[]);
    setLoading(false);
  }, [driverId]);

  useEffect(() => {
    if (!driverId) {
      setLoading(false);
      return;
    }
    setLoading(true);
    refetch();
    const unsub = subscribeTable('transactions', refetch, `driver_id=eq.${driverId}`);
    return unsub;
  }, [driverId, refetch]);

  return { transactions, loading, error, refetch };
}
